import type { GuildState } from '@/types/app-state';
import type { DashboardSnapshot } from '@/types/domain';

export function getDashboardSnapshot(state: GuildState): DashboardSnapshot {
  return {
    pendingUsers: state.profiles
      .filter((profile) => profile.approvalStatus === 'pending')
      .sort((left, right) => new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime()),
    recentAuditLogs: [...state.auditLogs]
      .sort((left, right) => new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime())
      .slice(0, 6),
    templates: state.templates,
    templateSlots: state.templateSlots,
    weapons: state.weapons,
    stats: {
      activeMasses: state.events.filter((event) => event.status === 'open' || event.status === 'upcoming').length,
      pendingApprovals: state.profiles.filter((profile) => profile.approvalStatus === 'pending').length,
      activeWeapons: state.weapons.filter((weapon) => weapon.isActive).length,
      archivedMasses: state.events.filter((event) => event.status === 'archived').length,
    },
  };
}
